import { Checkbox, Divider } from '@mui/material'
import { useContext } from 'react'
import { AppStateContext } from '../../../state/AppProvider'
import { FormFieldLabel } from '../../form/FormFieldLabel'
import { FileList } from '../FileComponentLegacy/FIleList'
import styles from '../FormStepsLegacy.module.css'
import { getBooleanValue, getValue } from '../helpers'
import { LegacyDisplayField } from '../LegacyDisplayField'
import completionLegacyStyles from './CompletionLegacy.module.css'

export const CompletionLegacy = () => {
  const appStateContext = useContext(AppStateContext)
  const completion = appStateContext?.state.currentChat?.extended_data?.experiment?.completion
  const approval =
    appStateContext?.state.currentChat?.extended_data.experiment?.extra_data.approval.field_value ?? false

  return (
    <div className={styles.stepContainer}>
      <div className={styles.fieldContainerSpaced}>
        <LegacyDisplayField
          label="Hypothesis Proven"
          value={getBooleanValue(completion?.hypothesis_proven?.field_value)}
          className={completionLegacyStyles.fieldItem150}
        />
        <LegacyDisplayField
          label="Confidence in Results"
          value={getValue(completion?.confidence_in_results?.field_value)}
          className={completionLegacyStyles.fieldItem150}
        />
        <LegacyDisplayField
          label="Total Experiment DME Spend (USD)"
          value={getValue(completion?.total_experiment_dme_spend?.field_value)}
          className={completionLegacyStyles.fieldItem150}
        />
      </div>
      <LegacyDisplayField
        label="Additional Comments"
        value={getValue(completion?.additional_comments?.field_value)}
      />
      <Divider className={styles.divider} />
      <FormFieldLabel text="As an OU Orchestrator, please take a moment to review all uploaded information and documents. By checking this box, you confirm that you have completed your review and acknowledge the contents." />
      <div className={completionLegacyStyles.approvalFieldContainer}>
        <Checkbox
          checked={approval}
          disabled
          size="small"
          className={completionLegacyStyles.approvalCheckbox}
        />
        <p className={completionLegacyStyles.approvalText}>
          I have reviewed and acknowledged all information and documents.
        </p>
      </div>
      <div className={styles.sectionTitleContainer}>
        <Divider className={styles.divider} />
        <p className={styles.sectionTitle}>Files Uploaded</p>
      </div>
      <ul>
        <li>If you have any questions about which the files uploaded, please contact support</li>
      </ul>
      <div>
        <FormFieldLabel text="Upload Result Deck" />
        <div className={styles.fileListContainer}>
          <FileList
            files={completion?.upload_result_deck?.field_value}
            field="upload_result_deck"
          />
        </div>
      </div>
      <div>
        <FormFieldLabel text="Upload other supporting data" />
        <div className={styles.fileListContainer}>
          <FileList
            files={completion?.other_supporting_data?.field_value}
            field="other_supporting_data"
          />
        </div>
      </div>
    </div>
  )
}
